export const ToggleOn = () => {
    return (
        <svg width="51" height="32" viewBox="0 0 51 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_479_1142)">
        <rect width="51" height="32" rx="16" fill="#296D87"/>
        <g filter="url(#filter0_ddd_479_1142)">
        <rect x="22" y="2" width="27" height="27" rx="13.5" fill="white"/>
        </g>
        </g>
        <defs>
        <filter id="filter0_ddd_479_1142" x="14" y="-3" width="43" height="43" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="3"/>
        <feGaussianBlur stdDeviation="0.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_479_1142"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="3"/>
        <feGaussianBlur stdDeviation="4"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="effect1_dropShadow_479_1142" result="effect2_dropShadow_479_1142"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect3_dropShadow_479_1142"/>
        <feOffset/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
        <feBlend mode="normal" in2="effect2_dropShadow_479_1142" result="effect3_dropShadow_479_1142"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_479_1142" result="shape"/>
        </filter>
        <clipPath id="clip0_479_1142">
        <rect width="51" height="32" rx="16" fill="white"/>
        </clipPath>
        </defs>
        </svg>
    );
  };